import React, { useId } from 'react'
import { FormikProps, getIn } from 'formik'
import { CodeInput } from '../Input/CodeInput'
import { ErrorLabel, Label } from '..'
import { FontSize } from '../../../_metronic/helpers'

interface FormCodeInputProps {
  formik: FormikProps<any>
  name: string
  label?: string
  length?: number
  className?: string
  isDisabled?: boolean
  isRequired?: boolean
  labelSize?: FontSize
  infoText?: string
  autoFocus?: boolean
}

export const FormCodeInput: React.FC<FormCodeInputProps> = ({
  formik,
  name,
  label,
  length = 6,
  className = '',
  isDisabled = false,
  isRequired = false,
  labelSize,
  infoText,
  autoFocus = false,
}) => {
  const errorMessage = getIn(formik.errors, name, null)
  const touched = getIn(formik.touched, name, '')
  const value = getIn(formik.values, name, '')

  const reactId = useId()
  const inputId = `${name}-${reactId}`
  const invalido = Boolean(touched && errorMessage)

  return (
    <div className={`row ${className}`}>
      {label && (
        <Label
          className='mb-2'
          htmlFor={inputId}
          isRequired={isRequired}
          size={labelSize}
          infoText={infoText}
        >
          {label}
        </Label>
      )}
      <CodeInput
        id={inputId}
        name={name}
        value={value}
        length={length}
        autoFocus={autoFocus}
        disabled={formik.isSubmitting || isDisabled}
        isInvalid={invalido}
        onChange={(event) => formik.setFieldValue(name, event.target.value)}
        onBlur={formik.handleBlur}
      />
      {invalido && <ErrorLabel>{errorMessage}</ErrorLabel>}
    </div>
  )
}
